<template>
  <span>
    <!--//at.alicdn.com/t/font_1617611_sj3wkdnhkci.js-->
    <remote-js src="//at.alicdn.com/t/font_1645063_0z6lws1lte8c.js"></remote-js>
    <svg class="svg-icon" aria-hidden="true" :style="{ width:size(width), height:size(height) }">
      <use :xlink:href="iconName"></use>
    </svg>
  </span>
</template>

<script>
  export default {
    name: "IconSvg",
    props:{
      iconClass:  { type: String, require: true},
      sizeNumber: { type:Number | String , default:2 },
      width: { type:Number | String , default:'' },
      height: { type:Number | String , default:'' }
    },
    computed:{
      iconName(){ return `#`+this.iconClass }
    },
    methods:{
      size( number ){
        return number ? number+ 'px' : this.sizeNumber+'em'
      }
    },
    //定义私有组件
    components:{
      'remote-css': {
        render(createElement) {
          return createElement('link', { attrs: { rel: 'stylesheet', href: this.href }});
        },
        props: {
          href: { type: String, required: true },
        },
      },
      'remote-js': {
        render(createElement) {
          return createElement('script', { attrs: { type: 'text/javascript', src: this.src }});
        },
        props: {
          src: { type: String, required: true },
        },
      },
    }
  }
</script>

<style scoped lang="stylus">
.svg-icon
  display: inline-block
  text-align: center;
  transition: all .3s;
  fill: currentColor;
  overflow: hidden;
  line-height: 1;
</style>
